import { format, isToday, isYesterday } from "date-fns";

export default function todayOrYesterday(dateObj?: Date | number): string {
  if (!dateObj) {
    return "";
  }

  const timeFormatForOutput = "HH:mm:ss '(UTC'xxx')'";
  const dateFormat = "EEE MMM d, yyyy";
  const dateTimeFormat = `${dateFormat} 'at' ${timeFormatForOutput}`;

  if (isToday(dateObj)) {
    return `Today at ${format(dateObj, timeFormatForOutput)}`;
  }

  if (isYesterday(dateObj)) {
    return `Yesterday at ${format(dateObj, timeFormatForOutput)}`;
  }

  return format(dateObj, dateTimeFormat);
}

/**
 * Formats a date string to "Month, Year" format for CSV export
 * @param dateString - ISO date string or any valid date string
 * @returns Formatted string like "January, 2024" or original string if parsing fails
 */
export function formatDateToMonthYear(dateString: string): string {
  try {
    const date = new Date(dateString);

    // Check if the date is invalid
    if (isNaN(date.getTime())) {
      return dateString;
    }

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];

    // Use UTC methods to avoid timezone conversion issues
    const monthIndex = date.getUTCMonth();
    const year = date.getUTCFullYear();

    // Additional validation for valid month and year
    if (monthIndex < 0 || monthIndex > 11 || isNaN(year)) {
      return dateString;
    }

    return `${monthNames[monthIndex]}, ${year}`;
  } catch {
    // Fallback to original string if parsing fails
    return dateString;
  }
}
